import styled from "styled-components";

export const HomepageHeaderArenaTitleDefaultBox = styled.div`
  position: relative;
  font-size: 1.4rem;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 1px;
  color: ${props => props.theme.colors.textLight};
  margin: 0 auto;
  width: fit-content;
  z-index: 1;
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    font-size: 0.9rem;
  }
`;
